import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const SearchContext = createContext({
  isOpen: false,
  openSearch: () => {},
  closeSearch: () => {},
});

/**
 * Wrap the app in <SearchProvider> so any component can open the site search
 * via useSiteSearch().openSearch(). Also registers the Cmd+K / Ctrl+K shortcut.
 */
export const SearchProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openSearch = useCallback(() => setIsOpen(true), []);
  const closeSearch = useCallback(() => setIsOpen(false), []);

  // Cmd+K / Ctrl+K keyboard shortcut
  useEffect(() => {
    const down = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setIsOpen((open) => !open);
      }
    };
    window.addEventListener('keydown', down);
    return () => window.removeEventListener('keydown', down);
  }, []);

  const value = useMemo(
    () => ({ isOpen, openSearch, closeSearch }),
    [isOpen, openSearch, closeSearch]
  );

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSiteSearch = () => useContext(SearchContext);
